export const subtitles = {
    "1": {
        "startTime": 6.35,
        "endTime": 7.11,
        "transcript": "Yaa.",
        "translation": "Ready."
    },
    "2": {
        "startTime": 7.65,
        "endTime": 11.98,
        "transcript": "Yaa, kitek' au͡gna kiuyullerpenek kiukiu.",
        "translation": "Okay, please answer that how you want."
    },
    "3": {
        "startTime": 12.82,
        "endTime": 15.01,
        "transcript": "Nutaan kitak' qanrutkiu.",
        "translation": "Please say it again."
    },
    "4": {
        "startTime": 15.024,
        "endTime": 31.249,
        "transcript": "Ii-i. Man'a-qaa Yuut qanruyutait ak'anek, ak'a tamaakenirnek piugurallret cangallrunritut agayuvigtarni qanruyutni?",
        "translation": "Okay. Is the anceint Yup'ik wisdom, the ones that have been since ancient times, no different from wisdom of the church?"
    },
    "5": {
        "startTime": 31.26,
        "endTime": 33.34,
        "transcript": "Iciw' igausngalriani Bible-aani?",
        "translation": "You know, the ones written in the Bible?"
    },
    "6": {
        "startTime": 33.345,
        "endTime": 41.705,
        "transcript": "Ii-i. Tua-i cangallruvken[ateng]. Maaten Bible-aani imkut, imkuuluteng tua-i qanruyuteput.",
        "translation": "Yes. They are no different. We found that in the Bible, they were our traditional wisdom."
    },
    "7": {
        "startTime": 42.93,
        "endTime": 52.98,
        "transcript": "Agayuvigmi-ll' wiinga, agayuyaryaqlirqama-llu qanruyutellrenka imkut elitaqaqluki qalarqura'arqata.",
        "translation": "And when I was in the church, when I finally went to church, I would recognize the traditional wisdom passed down to me when they spoke."
    },
    "8": {
        "startTime": 54.27,
        "endTime": 59.25,
        "transcript": "Elitaqa'artaqluki qanruyutellrenka imkut.",
        "translation": "I would recognize the traditional wisdom passed down to me."
    },
    "9": {
        "startTime": 64.385,
        "endTime": 68.955,
        "transcript": "Arnat-qaa uingvailegmeng qaillun alerquumalallruat?",
        "translation": "How would the women be instructed before taking husbands?"
    },
    "10": {
        "startTime": 69.155,
        "endTime": 74.145,
        "transcript": "Aren, angutet wangkutni alingnarqellruut.",
        "translation": "Oh my, the men were scary to us."
    },
    "11": {
        "startTime": 74.755,
        "endTime": 77.815,
        "transcript": "Angutet alingnarqellruut.",
        "translation": "The men were scary."
    },
    "12": {
        "startTime": 78.66,
        "endTime": 84.96,
        "transcript": "Aipaqnguayuunata-llu, tass'uqellriamek-llu tangssuunata.",
        "translation": "And we wouldn't play with each other informally, and we wouldn't see anyone holding hands."
    },
    "13": {
        "startTime": 86.115,
        "endTime": 89.405,
        "transcript": "Uumi alingnaqpiarluteng angutet.",
        "translation": "Long ago, men were very scary."
    },
    "14": {
        "startTime": 89.495,
        "endTime": 92.235,
        "transcript": "Wii tua-i alikellruanka.",
        "translation": "I was scared of them."
    },
    "15": {
        "startTime": 92.455,
        "endTime": 99.285,
        "transcript": "Qingallerkaqa-ll' tua-i niiqurluku tauggun wii aanamnek-wa.",
        "translation": "And I would hear about how I would get pregnant from my mother."
    },
    "16": {
        "startTime": 102.345,
        "endTime": 108.375,
        "transcript": "Umyuaqenrilkemteńek-llu uingaqluta, umyuaqsugnailkemteńek.",
        "translation": "And we would take husbands whom we never expected, those we did not expect at all."
    },
    "17": {
        "startTime": 115.335,
        "endTime": 120.635,
        "transcript": "Arnaurtellerkam-mi agleryaram tungiinun qaill' qanlallruat?",
        "translation": "What wouold they say about becoming a woman with first mensturations?"
    },
    "18": {
        "startTime": 120.65,
        "endTime": 127.24,
        "transcript": "Agleryaraq-llu tua-i eyagcetaqluta.",
        "translation": "And for first menstruations, they would have us abstain."
    },
    "19": {
        "startTime": 129.66,
        "endTime": 138.32,
        "transcript": "Tang arnaurtaqamta tua-i alingpiaqluta angutni.",
        "translation": "When we became women, the men feared us a lot."
    },
    "20": {
        "startTime": 139.925,
        "endTime": 142.805,
        "transcript": "Arnaq-gguq tuquuguq.",
        "translation": "They say that a woman leads to death."
    },
    "21": {
        "startTime": 145.04,
        "endTime": 152.81,
        "transcript": "Alingaqlua wiinga. Arniqevkariciqniluta-ll' qanrutaqluta.",
        "translation": "I would be scared. And they would tell us that we would make men crazed for women."
    },
    "22": {
        "startTime": 153.28,
        "endTime": 156.38,
        "transcript": "Maa-i arniqsuirutellriit.",
        "translation": "Now, they don't get woman-crazed."
    },
    "23": {
        "startTime": 157.785,
        "endTime": 169.755,
        "transcript": "Makut nasaurluut aglenrraraat aqumgavkalallruit qulni ernerni-gguq.",
        "translation": "They said that they would have girls with their first menstruations abstain for ten days."
    },
    "24": {
        "startTime": 169.765,
        "endTime": 171.795,
        "transcript": "Aqumgavkarluki-gguq.",
        "translation": "They called it aqumgaluteng."
    },
    "25": {
        "startTime": 172.955,
        "endTime": 175.155,
        "transcript": "Tamana-qaa elpet atullrunritan?",
        "translation": "Did you not go through that?"
    },
    "26": {
        "startTime": 175.17,
        "endTime": 176.97,
        "transcript": "Atullruaqa.",
        "translation": "I went through it."
    },
    "27": {
        "startTime": 176.985,
        "endTime": 186.035,
        "transcript": "Aqumgalua tua-i canek, canek-wa tua-i at'ellua.",
        "translation": "I abstained, and they had me put on certain clothes."
    },
    "28": {
        "startTime": 187.145,
        "endTime": 194.395,
        "transcript": "Tua-i kiarcecuunii-llu. Kiarteksaunii.",
        "translation": "And they wouldn't have me look around the area. I wouldn't look around the area."
    },
    "29": {
        "startTime": 194.405,
        "endTime": 197.175,
        "transcript": "Kiartelallilrianga-llu-w' iliini.",
        "translation": "I may have looked around sometimes."
    },
    "30": {
        "startTime": 200.405,
        "endTime": 204.635,
        "transcript": "(Inerquutetarluni?) Inerquumaluta tua-i.",
        "translation": "(Were there admonishments?) Were were admonished."
    },
    "31": {
        "startTime": 204.655,
        "endTime": 212.675,
        "transcript": "Tua-i-ll' nangercamta atlinqigtelluta. Yagtelluta.",
        "translation": "And when we stood up, they would have us replace what we were sitting on. They would have us raise our hands."
    },
    "32": {
        "startTime": 212.9,
        "endTime": 217.69,
        "transcript": "Meq tua-i alingcirarautekaqluku.",
        "translation": "They would warn us about water."
    },
    "33": {
        "startTime": 217.73,
        "endTime": 222.66,
        "transcript": "Waten mat'um nalliini wii watmi aglellruunga.",
        "translation": "During this time, I had my first menstruations."
    },
    "34": {
        "startTime": 224.79,
        "endTime": 228.8,
        "transcript": "(Ciin-gguq meq inerquutekluku?) Takvigituuq-gguq watmi?",
        "translation": "(Why did they admonish against water?) They say can see you better at this time."
    },
    "35": {
        "startTime": 233.13,
        "endTime": 234.85,
        "transcript": "Qassaq-llu.",
        "translation": "And raw meat."
    },
    "36": {
        "startTime": 244.505,
        "endTime": 246.085,
        "transcript": "Kiarceciiganaci-llu-qaa?",
        "translation": "And you couldn't look around?"
    },
    "37": {
        "startTime": 246.1,
        "endTime": 251.35,
        "transcript": "Ii-i, canek kiartesqeksaitaqluta. (Ciin-gguq?)",
        "translation": "Yes, they told us not to look around the area. (Why?)"
    },
    "38": {
        "startTime": 251.75,
        "endTime": 256.6,
        "transcript": "Naamelliin. Iingiucara'arnayukluki-w' pilallikait.",
        "translation": "I don't know. They probably told us our eyesight would go early."
    },
    "39": {
        "startTime": 257.68,
        "endTime": 265.45,
        "transcript": "Makut-llu-qaa tua-i tan'gaurluut pairqengaqavciki?",
        "translation": "And when you were going to cross paths with these boys?"
    },
    "40": {
        "startTime": 265.46,
        "endTime": 268.76,
        "transcript": "Ii-i, tuaten tua-i piaqluteng.",
        "translation": "Yes, they would do that."
    },
    "41": {
        "startTime": 269.045,
        "endTime": 270.505,
        "transcript": "Qaill' pisqaqluki?",
        "translation": "What would they tell them to do?"
    },
    "42": {
        "startTime": 270.55,
        "endTime": 278.03,
        "transcript": "Iciw' uqritgun. Nalirnerteggun-wa kituusqelartatki.",
        "translation": "You know, downwind from them. They tell them to pass in some direction."
    },
    "43": {
        "startTime": 280.175,
        "endTime": 281.315,
        "transcript": "Ciin-gguq?",
        "translation": "Why?"
    },
    "44": {
        "startTime": 282.06,
        "endTime": 284.39,
        "transcript": "Naam, ellaita-wa.",
        "translation": "I don't know, something about them."
    },
    "45": {
        "startTime": 288.436,
        "endTime": 308.329,
        "transcript": "Tua-ll' tamaani-qaa yuut nunallgutkenrilnguut yugnek tangrraqameng akluitgun elitaq'lallruit camiunguciit?",
        "translation": "And then, back when people who weren't from the same village saw others, would they recognize where they were from by what they wore?"
    },
    "46": {
        "startTime": 309.067,
        "endTime": 317.167,
        "transcript": "Qaralingqetullruut-gguq tuaten atkuit-llu.",
        "translation": "They said they had decorations like that, including their parkas."
    },
    "47": {
        "startTime": 320.641,
        "endTime": 324.508,
        "transcript": "Tamakumiut tuaten qaralingqerraqluteng.",
        "translation": "People from a certain area had unique decorations."
    },
    "48": {
        "startTime": 326.103,
        "endTime": 329.047,
        "transcript": "Elpeci-mi canek qaralingqellruceci?",
        "translation": "What kind of decorations did you have?"
    },
    "49": {
        "startTime": 329.22,
        "endTime": 331.909,
        "transcript": "Naamell'.",
        "translation": "I don't know."
    },
    "50": {
        "startTime": 338.033,
        "endTime": 340.944,
        "transcript": "Makut-qaa imkut...",
        "translation": "Did these..."
    },
    "51": {
        "startTime": 345.848,
        "endTime": 355.724,
        "transcript": "Qanemcitangqertuq-am tayima nani makunek elliranek.",
        "translation": "There are stories somewhere about these orphans."
    },
    "52": {
        "startTime": 357.056,
        "endTime": 367.834,
        "transcript": "Niitelartukut Kass'at tainginanermeggni, natmun tainginanermeggni nataqutniluteng, aa, sandbar...",
        "translation": "We hear that as the Caucasians were coming, as they were coming somewhere, that they found a, um, sandbar..."
    },
    "53": {
        "startTime": 368.294,
        "endTime": 369.694,
        "transcript": "Qau͡gyaq-qaa?",
        "translation": "A qau͡gyaq?"
    },
    "54": {
        "startTime": 373.408,
        "endTime": 379.373,
        "transcript": "Elliramek unitellratnek yuut qikertam...",
        "translation": "And orphan that people abandoned on an island..."
    },
    "55": {
        "startTime": 379.396,
        "endTime": 386.019,
        "transcript": "That's not how it... (Yaa, on a sandbar.) On a small island, I guess so, but it was on a sandbar.",
        "translation": "That's not how it... (Yes, on a sandbar.) On a small island, I guess so, but it was on a sandbar."
    },
    "56": {
        "startTime": 386.024,
        "endTime": 390.358,
        "transcript": "Tamakut-qaa ellirat allakaukelallruit yuut?",
        "translation": "Would people discriminate against those orphans?"
    },
    "57": {
        "startTime": 390.498,
        "endTime": 396.243,
        "transcript": "Elliraat tua-i inerquutekpiaraqluki. Inerquutekluki.",
        "translation": "They had strong adminishments about orphans. They had admonishments about them."
    },
    "58": {
        "startTime": 397.131,
        "endTime": 407.731,
        "transcript": "Inerquagaqluta nakukengraitki-ll' ilagauteqaasqevkenata elli'irnun, elliraat.",
        "translation": "They would admonish us that even if others picked on orphans, never to join them."
    },
    "59": {
        "startTime": 409.302,
        "endTime": 411.002,
        "transcript": "Ciin tanem?",
        "translation": "Why so?"
    },
    "60": {
        "startTime": 411.716,
        "endTime": 422.627,
        "transcript": "Well, they had admonishments about orphans.",
        "translation": "Well, they had admonishments about orphans."
    },
    "61": {
        "startTime": 422.937,
        "endTime": 433.241,
        "transcript": "Inerquraqluta tangnerrlugnarqellrianun-llu iciw' engelarturangraata ilagauteqaasqevkenata.",
        "translation": "And they would admonish us that even if they, you know, made fun of people that looked funny, never to join them."
    },
    "62": {
        "startTime": 435.724,
        "endTime": 439.146,
        "transcript": "Kia auluk'lallruitki ellirat?",
        "translation": "Who would take care of the orphans?"
    },
    "63": {
        "startTime": 440.274,
        "endTime": 455.264,
        "transcript": "Elliraat imumi check-angyuitellermeggni tua-i arnam-llu uum aulukeqtararaqluku, tau͡gaam tungelqurrita tegutuyugnarqait.",
        "translation": "Back when they wouldn't get checks, a woman would take care of the dear orphan, but I think their relatives would take them in."
    },
    "64": {
        "startTime": 455.371,
        "endTime": 461.171,
        "transcript": "Tegutullruyugnarqait tuaten atairutaqata.",
        "translation": "I think they took them in when they lost their fathers."
    },
    "65": {
        "startTime": 468.148,
        "endTime": 473.026,
        "transcript": "Tua-ll' inuguangqelallrullilriaten-wa tayima.",
        "translation": "And then, you probably had a small doll."
    },
    "66": {
        "startTime": 473.05,
        "endTime": 482.294,
        "transcript": "Inuguarcuutngullruunga wii. Inuguarturatullruukuk Caikaq-llu.",
        "translation": "I was never without a small doll. Caikaq and I would always play with small dolls."
    },
    "67": {
        "startTime": 483.937,
        "endTime": 488.053,
        "transcript": "Tua-i-qaa canek taukut inuguat",
        "translation": "And so, did your small dolls"
    },
    "68": {
        "startTime": 490.234,
        "endTime": 495.578,
        "transcript": "Ayuqsuitellruut-qaa naanguaci uksumi aturcuutekat wall'u kiagmi?",
        "translation": "Did you have different toys for the winter or the summer?"
    },
    "69": {
        "startTime": 495.591,
        "endTime": 498.813,
        "transcript": "Yaa, uksumi yaaruiq.",
        "translation": "Yes, there were storyknives in the winter."
    },
    "70": {
        "startTime": 499.876,
        "endTime": 507.787,
        "transcript": "Tua-i yaaruigura[raqluta]. Maa-i tang yaaruilriamek-llu tangssuunata, inugualrianek-llu tangssuunata.",
        "translation": "We would always tell storyknife stories. Now, we don't see anyone telling storyknife stories, and don't see anyone playing with small dolls."
    },
    "71": {
        "startTime": 508.12,
        "endTime": 513.325,
        "transcript": "Caugat-mi inuguat irniaruat-llu?",
        "translation": "What are inuguat (small dolls), and irniaruat (dolls)?"
    },
    "72": {
        "startTime": 513.352,
        "endTime": 521.374,
        "transcript": "Irniaruat-llu tua-i cat tekitaqata yaqulget anutaqluki inuguat-llu.",
        "translation": "When different things, birds, came, they would take out small dolls and dolls."
    },
    "73": {
        "startTime": 523.341,
        "endTime": 524.555,
        "transcript": "Ciin-gguq?",
        "translation": "Why?"
    },
    "74": {
        "startTime": 525.168,
        "endTime": 529.123,
        "transcript": "Anucuunaki uksumi, qemagngaluki tua-i.",
        "translation": "They didn't take them out in the winter, but kept them stored."
    },
    "75": {
        "startTime": 529.142,
        "endTime": 540.708,
        "transcript": "Tua-i-ll' nutaan yaqulget, cat yungat tekitaqata pilliut, anulluki inuguat irniaruat-llu.",
        "translation": "And then when the birds came, probably the jaegers, they would take out the small dolls and the dolls."
    },
    "76": {
        "startTime": 543.737,
        "endTime": 545.393,
        "transcript": "Ciin tanem?",
        "translation": "Why so?"
    },
    "77": {
        "startTime": 545.519,
        "endTime": 550.353,
        "transcript": "Naam. Kencikellruamegteggu-w' ella.",
        "translation": "I don't know. Because they revered nature."
    },
    "78": {
        "startTime": 555.898,
        "endTime": 561.171,
        "transcript": "Niitelartua-llu manalrianek kanani Mamterillermi.",
        "translation": "I also hear about people jiggin down in Bethel."
    },
    "79": {
        "startTime": 561.529,
        "endTime": 566.141,
        "transcript": "Cang'urluteng-gguq manarnaurtut, tua-i-llu-gguq-am catairrluteng neqet.",
        "translation": "They say they would catch fish, then the fish would disappear."
    },
    "80": {
        "startTime": 566.864,
        "endTime": 575.308,
        "transcript": "Ilait qanlartut, \"Aglenrrar-wam wall'u-qaa irnicuanerrar manaryallrullian tamaqallilriit.\" Tamana-qaa piciu[guq]?",
        "translation": "Some say, \"They probably disappeared because a girl within the first year of her menstruations or one who miscarried is jigging.\" Is that true?"
    },
    "81": {
        "startTime": 575.316,
        "endTime": 577.749,
        "transcript": "Tamana piciuyugnarquq.",
        "translation": "That's probably true."
    },
    "82": {
        "startTime": 578.806,
        "endTime": 580.595,
        "transcript": "Allanek-qaa tuaten...",
        "translation": "Were there others like that..."
    },
    "83": {
        "startTime": 581.309,
        "endTime": 587.464,
        "transcript": "Tuaten tua-i maaten murilkua tuaten qanraqluteng inerquutnguluni.",
        "translation": "When I observed them, I found that they would say that as an admonishment."
    },
    "84": {
        "startTime": 595.914,
        "endTime": 614.307,
        "transcript": "Tua-ll' ak'a tamaani Kass'at pingssiyaagpailgata atrit'lallruyugnarqut mikelnguut ayagyuat.",
        "translation": "And then, back before there were a lot of Caucasians, I don't think young children had names."
    },
    "85": {
        "startTime": 614.863,
        "endTime": 628.646,
        "transcript": "Niitelallruunga waten: kituucianek una aptaqamegteggu kiunauraa waten: \"Uum irniaqaanga,\" wall'u-q' \"Uum yuliaqaanga.\"",
        "translation": "I used to hear this: when they would ask him what his name was, he would answer, \"I am this person's child,\" or \"I am this person's adopted child.\""
    },
    "86": {
        "startTime": 628.686,
        "endTime": 630.786,
        "transcript": "Tuaten-qaa niitelallruuten?",
        "translation": "Did you hear about that?"
    },
    "87": {
        "startTime": 630.867,
        "endTime": 638.2,
        "transcript": "Niitelallruunga. Atrit'lallruyugnarqut Kass'atun, Yugtun tau͡gaam.",
        "translation": "I used to hear that. They probably didn't have English names, only Yup'ik ones."
    },
    "88": {
        "startTime": 639.593,
        "endTime": 642.56,
        "transcript": "Qaillun-mi atenglallruat?",
        "translation": "So how would they get names?"
    },
    "89": {
        "startTime": 645.825,
        "endTime": 650.559,
        "transcript": "Acilallikait. Acilaqput-wa maa-i.",
        "translation": "They probably named them. We name them now."
    },
    "90": {
        "startTime": 653.352,
        "endTime": 658.608,
        "transcript": "Nuu, tua-i-w' iciw' agayuvigmun agulluki angllurcelluki acilaqait?",
        "translation": "No, you know how they bring them to the church, and baptize them with names?"
    },
    "91": {
        "startTime": 658.62,
        "endTime": 666.331,
        "transcript": "Ak'a tamaani qaillun acilallruitki agayuvingvailgata makut Yuut Yupiarullratni?",
        "translation": "How did they name them before there were churches, when Yupiit lived traditional lives?"
    },
    "92": {
        "startTime": 666.969,
        "endTime": 671.947,
        "transcript": "Yugtarnek-wa acitullrullikai, acitukai.",
        "translation": "They would give them Yup'ik names."
    },
    "93": {
        "startTime": 673.397,
        "endTime": 680.53,
        "transcript": "Wangkuta uani Qinarmi mission-aartarmek tau͡gaam tua-i agayuvingqellruukut.",
        "translation": "Downriver in Qinaq, we only had a mission church."
    },
    "94": {
        "startTime": 681.729,
        "endTime": 689.101,
        "transcript": "Tua-i agayuvikluku kiingan naucan.",
        "translation": "It was our only church when it was built."
    },
    "95": {
        "startTime": 690.576,
        "endTime": 696.987,
        "transcript": "Maaten ellangua wiinga agayuvigtaunani, tau͡gaam enetarluni mission-aartarmek.",
        "translation": "When I grew up, I found that there was no church, but a mission house."
    },
    "96": {
        "startTime": 697.434,
        "endTime": 701.656,
        "transcript": "Tuani agayuaqluteng, qasgimi-ll' agayuaqluteng.",
        "translation": "They would hold services there, and hold services in the community house."
    },
    "97": {
        "startTime": 705.593,
        "endTime": 710.615,
        "transcript": "Tua-i-ll' naulluku ak'allaq.",
        "translation": "And then they built the old one."
    },
    "98": {
        "startTime": 712.421,
        "endTime": 715.21,
        "transcript": "Tua-i kiingan agayuvikluku.",
        "translation": "It was their only church."
    },
    "99": {
        "startTime": 721.728,
        "endTime": 736.242,
        "transcript": "Ak'a-wa tamaani-llu makut yuut tuvqaku'urluteng pilallrullilriit ilameggnun.",
        "translation": "And long ago, these people probably always shared their food with each other."
    },
    "100": {
        "startTime": 736.732,
        "endTime": 744.421,
        "transcript": "Tua-i tuvqakulluteng ilakuyusnganateng.",
        "translation": "They shared their food with each other as if they were a single family."
    },
    "101": {
        "startTime": 748.899,
        "endTime": 757.299,
        "transcript": "Tua-i-w' mat'um nalliini makut ayagyuat qaillun qaneryarateng Yugcetun nalluyagutengluku.",
        "translation": "These days, these young people are started to forget how to speak their Yup'ik langauge."
    },
    "102": {
        "startTime": 757.46,
        "endTime": 765.249,
        "transcript": "Cali-llu Yuut, Yuut ak'a qanruyutait niicuirulluki.",
        "translation": "Also, they don't hear about traditional Yup'ik wisdom anymore."
    },
    "103": {
        "startTime": 767.513,
        "endTime": 780.124,
        "transcript": "Apqiitnek Kass'at saagarrluteng Yuut piciqnilarait qaneryuirutellriit wall'u-qaa kinkuuciteng nalluyagulluku.",
        "translation": "As they call it, Westernization will spread among Yupiit who don't speak Yup'ik or who forget who they are."
    },
    "104": {
        "startTime": 781.198,
        "endTime": 794.709,
        "transcript": "Wangkuta-qaa Yugni saagartellriatun ellirciqukut cam iliini qaneryuiruskumta Yugcetun wall'u-qaa niicuiruskumta Yugtarnek ak'allarnek tamakunek?",
        "translation": "Will we Yupiit be as if we were scattered someday if we don't speak Yup'ik anymore, or if we don't hear about those ancient Yup'ik things?"
    },
    "105": {
        "startTime": 794.723,
        "endTime": 797.367,
        "transcript": "Pillilriakut-wa.",
        "translation": "We probably will."
    },
    "106": {
        "startTime": 799.351,
        "endTime": 804.029,
        "transcript": "Qaneryaraq tua-i man'a tamayunaicaaquq.",
        "translation": "We shouldn't lose this language."
    },
    "107": {
        "startTime": 807.416,
        "endTime": 809.127,
        "transcript": "Ciin tanem?",
        "translation": "Why so?"
    },
    "108": {
        "startTime": 809.888,
        "endTime": 813.421,
        "transcript": "Nutem qaneryarauluni.",
        "translation": "It's an ancient language."
    },
    "109": {
        "startTime": 822.93,
        "endTime": 829.63,
        "transcript": "I'd kind of like to get Nicholai to say something in...",
        "translation": "I'd kin dof like to get Nicholai to say something in..."
    },
    "110": {
        "startTime": 831.134,
        "endTime": 834.551,
        "transcript": "Nicholai-aq kitek' piqerru, apteqerru.",
        "translation": "Please ask Nicholai a question."
    },
    "111": {
        "startTime": 836.239,
        "endTime": 850.206,
        "transcript": "Camek-gguq-qaa piciatun qanqeryuumiituq ayagyuat atu'urkaatnek ak'allarmek piciatun qanruyutmek?",
        "translation": "Ask him if he want's to say any ancient traditional wisdom that young people should follow."
    },
    "112": {
        "startTime": 851.811,
        "endTime": 853.067,
        "transcript": "Qaillun ima?",
        "translation": "What was it again?"
    },
    "113": {
        "startTime": 853.08,
        "endTime": 863.269,
        "transcript": "Yaa, apteqerru waten: qanruyutmek-gguq-qaa piciatun qanqeryuumiituq ayagyuat atullerkaatnek watua mat'um nalliini?",
        "translation": "Okay, as him like this: does he want to say anything that young people should follow in these days?"
    },
    "114": {
        "startTime": 864.488,
        "endTime": 872.121,
        "transcript": "Qanruyutmek-gguq ak'allarmek ayagyuat qanruyutiitnek qanqaa.",
        "translation": "He asked you to speak about ancient traditional wisdom concerning young people."
    },
    "115": {
        "startTime": 875.301,
        "endTime": 891.111,
        "transcript": "Wiinga tamaani tua-i tan'gurra'urluullemni",
        "translation": "Back when I was a boy"
    },
    "116": {
        "startTime": 893.163,
        "endTime": 906.78,
        "transcript": "Kanani enem, ena tauna yungqertuq angutngurrluni ayagyuarpek'nani.",
        "translation": "Down in that house, there was an old man, not young, in that house."
    },
    "117": {
        "startTime": 907.739,
        "endTime": 917.996,
        "transcript": "Tan'gaurluut waten tuavet atakumi quyurrluki.",
        "translation": "He would gather the boys there like this in the evening."
    },
    "118": {
        "startTime": 919.594,
        "endTime": 923.044,
        "transcript": "It'lallruukut.",
        "translation": "We would go in."
    },
    "119": {
        "startTime": 923.798,
        "endTime": 943.991,
        "transcript": "Tua-i taum im' angukara'urluum qanlallran ilii umyuaqela'arqa cali maa-i, cali ak'allaurcuunani.",
        "translation": "I still remember to this day one of the things that old man said, and it doesn't get old."
    },
    "120": {
        "startTime": 947.655,
        "endTime": 963.355,
        "transcript": "Tamaani tua-i taum angutem cunaw' qanrut'lallinikiikut tua-i-w' unguvallemteńi murilkelluta pisqelluta.",
        "translation": "Back then, it turned out that that man would tell us to be careful in our lives."
    },
    "121": {
        "startTime": 965.243,
        "endTime": 973.16,
        "transcript": "Cali-llu ilaput kenekluki-w' tua-i.",
        "translation": "Also, to treat those around us with love."
    },
    "122": {
        "startTime": 976.463,
        "endTime": 987.447,
        "transcript": "Cunaw' una kenekluki qanrumalria tamarmi yuum aturarkauyaaqellinikii-wa.",
        "translation": "It turned out that the saying to treat everyone with love was to be followed by every person."
    },
    "123": {
        "startTime": 988.367,
        "endTime": 999.034,
        "transcript": "Nutaan-llu tangerrsaaqeng'e'rmiu qanellgutkekuniu, tua-i ilaliurluku pisqumaluni.",
        "translation": "And even if he sees him for the first time, he wants to be spoken to and socialized with."
    },
    "124": {
        "startTime": 999.053,
        "endTime": 1006.47,
        "transcript": "Taum tua-i angutem man'a qanrutkelallrua.",
        "translation": "That man would speak about this."
    },
    "125": {
        "startTime": 1007.922,
        "endTime": 1018.652,
        "transcript": "Tua-i tau͡gaam caqerluni qanellra",
        "translation": "But what he said one day"
    },
    "126": {
        "startTime": 1019.74,
        "endTime": 1037.89,
        "transcript": "Cali wangkuta-w' neqnek nertulini yugni piitenritengnaqesqelluta taum angutem unguvallemteńi utumakumta pisqelluta.",
        "translation": "That old man also told us people who eat food to try not to run out, that we should subsist as we live if we are well."
    },
    "127": {
        "startTime": 1037.915,
        "endTime": 1049.981,
        "transcript": "Cunaw' una neqem cataitellra assiituq neqnek nertuluni.",
        "translation": "It turned out that being without food is bad for those who eat."
    },
    "128": {
        "startTime": 1051.818,
        "endTime": 1068.301,
        "transcript": "Tamaani tua-i neqkameggnek anglani'urlullrunritliniut makunek imkunek kuvyanek piilameng.",
        "translation": "The poor people couldn't afford to waste food because they didn't have these Western nets."
    },
    "129": {
        "startTime": 1068.839,
        "endTime": 1079.156,
        "transcript": "Tua-i tau͡gaam qilaganek-gguq ilait qaillun tua-i kuvyangqerraqluteng.",
        "translation": "However, he said that some would have nets made by knot-like tying."
    },
    "130": {
        "startTime": 1080.806,
        "endTime": 1086.439,
        "transcript": "Tuaten tua-i taum angutem, angukara'urluum qanrutkelallrui.",
        "translation": "That's how that man, old man, would speak of them."
    },
    "131": {
        "startTime": 1090.231,
        "endTime": 1104.364,
        "transcript": "Tamakut, pissuutnek-wa tua-i tamakut anglanillrunritliniut.",
        "translation": "Those, they couldn't afford to waste those tools."
    },
    "132": {
        "startTime": 1104.368,
        "endTime": 1117.301,
        "transcript": "Taumek tua-i-w' iliini apqiitnek kailallrullini[lriit] nurutaqluteng neqkameggnek.",
        "translation": "That's why they would sometimes, as they say, starve with a shortage of food."
    },
    "133": {
        "startTime": 1121.69,
        "endTime": 1127.69,
        "transcript": "Ciku-gguq cup'uq. Wifey-q-gguq qanrullaku cup'uq-gguq un'a. (Cup'uq.)",
        "translation": "They said the ice broke up. They told me to tell Wifey that the ice broke up. (It broke up.)"
    },
    "134": {
        "startTime": 1127.722,
        "endTime": 1132.788,
        "transcript": "Tua-i-w' nangqerrutellriakuk tape-amek. Quyanaqvaa.",
        "translation": "Well, we have no more tape. Thank you very much."
    },
    "135": {
        "startTime": 1132.973,
        "endTime": 1135.756,
        "transcript": "Tua-llu-w' qanenrulriaten.",
        "translation": "You spoke more."
    },
    "136": {
        "startTime": 1136.504,
        "endTime": 1137.604,
        "transcript": "Quyana.",
        "translation": "Thank you."
    },
    "137": {
        "startTime": 1138.745,
        "endTime": 1140.445,
        "transcript": "Quyana.",
        "translation": "Thank you."
    },
    "138": {
        "startTime": 1140.453,
        "endTime": 1141.27,
        "transcript": "Yaa.",
        "translation": "You're welcome."
    },
    "139": {
        "startTime": 1141.502,
        "endTime": 1145.086,
        "transcript": "Uum-llu waniwa aanii...",
        "translation": "And her mother..."
    }
};